import { create } from 'zustand';
import type { ReportEventDraft, ReportListItem } from '@/types/report';

export enum OverlayNames {
    SOURCE_UPLOAD = 'SOURCE_UPLOAD',
    ADD_CAMERA = 'ADD_CAMERA',
    ADD_EVENTS_TO_REPORT = 'ADD_EVENTS_TO_REPORT',
}

interface SourceFolderTarget {
    targetFolderId?: string;
}

export interface AddEventsToReportOverlayProps {
    report: ReportListItem;
    drafts: ReportEventDraft[];
    onAdded?: () => void;
}

interface OverlayPropsByName {
    [OverlayNames.SOURCE_UPLOAD]: SourceFolderTarget;
    [OverlayNames.ADD_CAMERA]: SourceFolderTarget;
    [OverlayNames.ADD_EVENTS_TO_REPORT]: AddEventsToReportOverlayProps;
}

interface OverlayState {
    overlays: Partial<OverlayPropsByName>;
    open: <Name extends OverlayNames>(
        type: Name,
        props: OverlayPropsByName[Name],
    ) => void;
    close: (type: OverlayNames) => void;
}

export const useOverlayStore = create<OverlayState>((set) => ({
    overlays: {},
    open: (type, props) =>
        set((state) => ({
            overlays: { ...state.overlays, [type]: props },
        })),
    close: (type) =>
        set((state) => {
            const { [type]: _, ...rest } = state.overlays;
            return { overlays: rest };
        }),
}));

export function useOverlayManager() {
    return {
        open: useOverlayStore((state) => state.open),
        close: useOverlayStore((state) => state.close),
    };
}
